// @flow

import radio from 'app/developer-v3/components/PartnerSupportForm/components/blocks/Radio';
import app from 'app/developer-v3/components/PartnerSupportForm/components/blocks/App';

import { createPublishingYourApp } from '../common/newOrExisitng/publishingYourApp';
import { createPartnerProgram } from '../common/newOrExisitng/partnerProgram';
import { createIssueOrBugs } from '../common/newOrExisitng/issuesOrBugs';
import { createZapTemplates } from '../common/newOrExisitng/zapTemplates';
import { buildingFirstTime } from '../common/newOrExisitng/buildingFirstTime';
import { createMaintainingMyApp } from '../common/newOrExisitng/maintainingMyApp';
import { createEmbeddingForPartners } from '../common/newOrExisitng/embedding';

const newOrExistingApp = app({
  label: `What app are you working on?`,
  developer: true,
  isRequired: false,
  child: radio({
    id: 'neworexisting',
    label: 'Tell us more',
    zendeskCustomFieldId: 360044601591,
    items: [
      buildingFirstTime(true, 'existing'), // Only rendered if selected app is not public
      createPublishingYourApp(true, 'existing'),
      createPartnerProgram(true),
      createEmbeddingForPartners(true),
      createZapTemplates(true),
      createMaintainingMyApp(true),
      createIssueOrBugs(),
    ],
  }),
});

export default newOrExistingApp;
